






































































import Vue from 'vue';
import { namespace } from 'vuex-class';
import { Component, Watch, Prop } from 'vue-property-decorator';
import { Validator } from 'vee-validate';

import Input from '@/shared/components/Inputs/Input.vue';
import Field from '@/shared/components/Field/Field.vue';
import ModalMobile from '@/shared/components/ModalMobile/ModalMobile.vue';

import ForgotPasswordMobile from './components/ForgotPasswordMobile.vue';

import { ICustomerAuth, ICustomer } from '@/interfaces/Customer';
import { ITraceableError } from '@/interfaces/Error';

import {
  EErrorScope,
  EErrorExhibition,
} from '@/helpers/enums';

const ErrorModule = namespace('App/Error');
const CustomerModule = namespace('App/Customer');

@Component({
  components: {
    ModalMobile,
    Input,
    Field,
    ForgotPasswordMobile
  }
})
export default class LoginMobile extends Vue {
  private validator = new Validator();

  private modalOpen = false;

  private form = {
    fields: {
      username: '',
      password: ''
    },
    states: {
      passwordShow: false
    },
    errors: this.validator.errors
  };

  @CustomerModule.State('isLoading')
  private isLoading: boolean;

  @CustomerModule.Action('signin')
  private signin!: ({customer, isEverywhere}: {customer: ICustomerAuth, isEverywhere?: boolean})=> Promise<any>;

  @ErrorModule.Getter('errorsByExhibitionAndScope')
  private errorsByExhibitionAndScope: Function;

  @ErrorModule.Mutation('hideErrorsByScope')
  private hideErrorsByScope: Function;

  private get signinErrorMessage() {
    const error = this.errorsByExhibitionAndScope(
      EErrorExhibition.alert,
      [EErrorScope.login]
    ).reverse().find((error: ITraceableError) => error.visibility);

    if (!error) {
      return null;
    }

    if (error.message) {
      return `Ops! ${error.message}`;
    }

    return this.$t('App.Checkout.Login.error');
  }

  private clearErrors() {
    return this.hideErrorsByScope(EErrorScope.login);
  }

  private togglePassword() {
    this.form.states.passwordShow = !this.form.states.passwordShow;
  }

  private submitForm() {
    this.validateForm().then(() => {
      this.signin({ customer: this.form.fields, isEverywhere: false });
    });
  }

  private validateForm() {
    return new Promise(async (resolve: any, reject) => {
      const result = await this.validator.validateAll({
        username: this.form.fields.username,
        password: this.form.fields.password
      });

      result ? resolve() : reject();
    });
  }

  private created() {
    this.validator.attach({
      name: 'username',
      rules: 'required|username'
    });

    this.validator.attach({
      name: 'password',
      rules: 'required'
    });
  }

  private destroyed() {
    this.validator.reset();
    this.clearErrors();
  }
}
